<template>
  <!-- 文章讯息 -->
  <div class="point">
    <div class="text">....</div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.point {
  height: 2.4rem;
  line-height: 2rem;
  border-top: 1px dashed #dfdfdf;
  font-size: 1rem;
  font-weight: 600;
}

.text {
  text-align: center;

  color: #666666;
}
</style>